module.exports = __webpack_public_path__ + "static/media/pointer-folded.35e07a33.svg";